export class Color {
	constructor(idColor, description, colorHexa) {
		this.idColor = idColor;
		this.description = description;
		this.hex = colorHexa;
	}
}
